<template>
  <div id="page-keyword-list-edit">
    <div>
      <vx-card v-if="editVisible">
        <keyword-edit
          :value="selectedItem"
          v-on:saved="saved"
          v-on:closed="closed"
        />
      </vx-card>
      <div v-show="!editVisible">
        <div class="vx-card__header pb-4 shadow">
          <div class="vx-card__title">
            <h4>Keywords</h4>
            <!---->
          </div>
          <div class="vx-card__actions">
            <vs-button
              @click="startAdd"
              color="primary"
              type="border"
              icon="add"
              >{{ $t("Keyword.New") }}</vs-button
            >
          </div>
        </div>

        <div class="card-body">
          <div class="flex flex-wrap items-center">
            <DxList
              key-expr="Id"
              :data-source="keywords"
              :height="500"
              :ref="listRefKey"
              @item-click="onItemClick"
            >
              <template #item="{ data: item }">
                <div class="keyword">
                  <div class="row">
                    <div class="middle">
                      <div class="con-vs-chip vs-chip-light p-3 text-lg px-10">
                        <span v-if="item.kind == 'Include'"
                          ><i
                            class="
                              vs-icon
                              notranslate
                              icon-scale
                              material-icons
                              small
                            "
                            style="color: green"
                            >check</i
                          ></span
                        >
                        <span v-if="item.kind == 'Exclude'"
                          ><i
                            class="
                              vs-icon
                              notranslate
                              icon-scale
                              material-icons
                              small
                            "
                            style="color: red"
                            >close</i
                          ></span
                        >
                        <strong class="ml-4 font-weight-bold">{{
                          getCaption(item)
                        }}</strong>
                        <small class="ml-4" v-show="item.exactMatch"
                          >(exact match)</small
                        >
                      </div>
                    </div>
                    <div class="right">
                      <vs-button
                        class="ml-4"
                        type="border"
                        @click.stop="confirmDelete(item.id, item.keyword)"
                        >{{ $t("Delete") }}</vs-button
                      >
                    </div>
                  </div>
                </div>
              </template>
            </DxList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup"
import { notifyMixin } from "@/mixins/notifyMixin"
import DxList from "devextreme-vue/list"
import KeywordEdit from "./KeywordEdit"
let _this = null
const listRefKey = "list-keywords"
const defaultKeyword = { id: 0, kind: "Include", value: "", exactMatch: false }
export default {
  mixins: [notifyMixin],
  props: {
    value: Array,
  },
  components: {
    DxPopup,
    DxList,
    KeywordEdit,
  },
  data () {
    return {
      keywords: [],
      listRefKey,
      editVisible: false,
      selectedItem: defaultKeyword,
    };
  },
  methods: {
    saved (keyword) {
      this.editVisible = false;
      console.log("selectedItem saved", keyword)
      if (keyword.id == 0) {
        let id = 0
        if (this.keywords.length > 0) {
          id = this.keywords[this.keywords.length - 1].id
        }
        keyword.value.split(",").forEach(word => {
          if (word) {
            id++
            const item = {...keyword, id, value: word.trim()}
            this.keywords.push(item)
          }
        })
        return
      } else {
        const existing = this.keywords.find((a) => a.id == keyword.id)
        existing.value = keyword.value
        existing.kind = keyword.kind
        existing.exactMatch = keyword.exactMatch
      }
      this.$emit("input", this.keywords)
    },
    getCaption (keyword) {
      return (
        // this.$t(`KeywordKind.${keyword.kind}`) +
        ` ${keyword.value} ${keyword.exactMatch ? "" : ""}`
      );
    },
    closed () {
      this.editVisible = false
    },
    refreshList () {
      this.editVisible = false
      const list = this.$refs[listRefKey].instance
      return list.reload()
    },
    startAdd () {
      this.selectedItem = defaultKeyword
      console.log("default", defaultKeyword)
      this.editVisible = true
    },
    startEdit (item) {
      this.selectedItem = item
      this.editVisible = true
    },
    onItemClick (e) {
      this.selectedItem = e.itemData
      this.editVisible = true
    },
    confirmDelete (id, keyword) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("ConfirmDelete"),
        text: this.$t("Keyword.DeleteQuestion", { keyword }),
        accept: () => this.delete(id),
        acceptText: this.$t("Delete"),
        cancelText: this.$t("Cancel"),
      });
    },
    delete (id) {
      this.keywords = this.keywords.filter((a) => a.id != id)
      this.$emit("input", this.keywords)
    },
  },
  created () {
    _this = this;
    this.keywords = this.value
  },
};
</script>
<style scoped>
.keyword {
  height: 65px;
}

.keyword p,
.keyword h4 {
  word-wrap: normal;
  white-space: normal;
}

.keyword h4 {
  margin-top: 0px;
  margin-bottom: 5px;
}

.row {
  min-height: 30px;
  width: 100%;
  display: flex;
  align-items: flex-end;
  margin-top: 5px;
}
.left {
  align-items: flex-center;
}
.middle {
  flex-grow: 1;
}
.right {
  align-items: flex-center;
}
</style>